import { isOgpSidebarPathAllowedForLimitedCompany } from 'ogp/limited-company-capabilities';
import { cloneSidebarItems } from './clone-sidebar-items';
import { withSectionChildren } from './ogp-sidebar-section-helpers';
import {
  OgpSidebarItems,
  OgpSidebarItemsSource,
  OgpSidebarSection,
} from './ogp-sidebar-items.types';

export const filterSidebarItemsForLimitedCompany = (
  sidebarItems: OgpSidebarItemsSource
): OgpSidebarItems =>
  cloneSidebarItems(sidebarItems)
    .map(
      (section): OgpSidebarSection =>
        withSectionChildren(
          section,
          section.children.filter((child) => isOgpSidebarPathAllowedForLimitedCompany(child.path))
        )
    )
    .filter((section) => section.children.length > 0);
